"use strict";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _get } from "@swc/helpers/_/_get";
import { _ as _get_prototype_of } from "@swc/helpers/_/_get_prototype_of";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _create_super } from "@swc/helpers/_/_create_super";
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _invariant = _interopRequireDefault(require("fbjs/lib/invariant"));
var React = _interopRequireWildcard(require("react"));
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */ /**
 * `setState` is called asynchronously, and should not rely on the value of
 * `this.props` or `this.state`:
 * https://reactjs.org/docs/state-and-lifecycle.html#state-updates-may-be-asynchronous
 *
 * SafePureComponent adds runtime enforcement, to catch cases where these
 * variables are read in a state updater function, instead of the ones passed
 * in.
 */ var StateSafePureComponent = /*#__PURE__*/ function(_React_PureComponent) {
    _inherits(StateSafePureComponent, _React_PureComponent);
    var _super = _create_super(StateSafePureComponent);
    function StateSafePureComponent(props) {
        _class_call_check(this, StateSafePureComponent);
        var _this;
        _this = _super.call(this, props);
        _this._inAsyncStateUpdate = false;
        _this._installSetStateHooks();
        return _this;
    }
    _create_class(StateSafePureComponent, [
        {
            key: "setState",
            value: function setState(partialState, callback) {
                var _this = this;
                if (typeof partialState === "function") {
                    _get(_get_prototype_of(StateSafePureComponent.prototype), "setState", this).call(this, function(state, props) {
                        _this._inAsyncStateUpdate = true;
                        var ret;
                        try {
                            ret = partialState(state, props);
                        } catch (err) {
                            throw err;
                        } finally{
                            _this._inAsyncStateUpdate = false;
                        }
                        return ret;
                    }, callback);
                } else {
                    _get(_get_prototype_of(StateSafePureComponent.prototype), "setState", this).call(this, partialState, callback);
                }
            }
        },
        {
            key: "_installSetStateHooks",
            value: function _installSetStateHooks() {
                var that = this;
                var props = this.props, state = this.state;
                Object.defineProperty(this, "props", {
                    get: function get() {
                        (0, _invariant.default)(!that._inAsyncStateUpdate, '"this.props" should not be accessed during state updates');
                        return props;
                    },
                    set: function set(newProps) {
                        props = newProps;
                    }
                });
                Object.defineProperty(this, "state", {
                    get: function get() {
                        (0, _invariant.default)(!that._inAsyncStateUpdate, '"this.state" should not be acceessed during state updates');
                        return state;
                    },
                    set: function set(newState) {
                        state = newState;
                    }
                });
            }
        }
    ]);
    return StateSafePureComponent;
}(React.PureComponent);
exports.default = StateSafePureComponent;
module.exports = exports.default;
